import { shallowRef } from 'vue'

// Set by the config store from the open project, so analytics services can read it without importing the store.
const current = shallowRef<string | null>(null)

export function setProjectTimezone(timezone: string | null | undefined): void {
  current.value = timezone || null
}

/** The open project's reporting timezone (General settings); the browser's until the project loads. Reactive. */
export function projectTimezone(): string {
  return current.value ?? Intl.DateTimeFormat().resolvedOptions().timeZone
}
